import { createActionCreator } from "deox";
import { IUserModel } from "../../../types/types";

export const userLoading = createActionCreator("userLoading");
export const userLoadingError = createActionCreator("userLoadingError");
export const setUserFetched = createActionCreator(
  "user/setFetched",
  (resolve) => (payload: boolean) => resolve(payload)
);

export const userLoaded = createActionCreator(
  "userLoaded",
  (resolve) => (payload: IUserModel) => resolve(payload)
);
